import React from 'react';
export function EnglishPrivacyPolicyContent() {
  return <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-80">
      <section data-id="element-81">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-82">
          1. Privacy at a glance
        </h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-83">
          General information
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-84">
          The following information provides a simple overview of what happens
          to your personal data when you visit this website. Personal data is
          any data that can be used to identify you personally. Detailed
          information on data protection can be found in this Privacy Policy.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-85">
          Data collection on this website
        </h3>
        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-86">
          Who is responsible for data collection on this website?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-87">
          Data processing on this website is carried out by the website
          operator. You can find the operator&apos;s contact details in the
          “Responsible Entity” section of this Privacy Policy.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-88">
          How do we collect your data?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-89">
          Some data is collected when you provide it to us, for example when you
          enter information into a contact form. Other data is collected
          automatically or with your consent by our IT systems when you visit
          this website. This is mainly technical data, such as your internet
          browser, operating system, or the time of page access.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-90">
          What do we use your data for?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-91">
          Some data is collected to ensure that the website is provided without
          errors. Other data may be used to analyse your use of the website.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-92">
          What rights do you have regarding your data?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-93">
          You have the right at any time to receive information free of charge
          about the origin, recipients and purpose of your stored personal data.
          You also have the right to request that this data be corrected or
          deleted. If you have given consent to data processing, you may revoke
          this consent at any time with future effect. You also have the right,
          in certain circumstances, to request restriction of processing and to
          lodge a complaint with the relevant supervisory authority.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-94">
          Analytics and third-party tools
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-95">
          When you visit this website, your browsing behaviour may be evaluated
          statistically. This is mainly done using analytics tools. Details are
          provided in the sections below.
        </p>
      </section>

      <section data-id="element-96">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-97">2. Hosting</h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-98">Webflow</h3>
        <p className="leading-relaxed mb-4" data-id="element-99">
          We host our website with Webflow. The provider is Webflow, Inc., 398
          11th Street, 2nd Floor, San Francisco, CA 94103, USA. When you visit
          our website, Webflow collects various log files, including your IP
          address.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-100">
          Webflow is a tool for building and hosting websites. Webflow stores
          cookies or other recognition technologies that are necessary for the
          display of the site, the provision of certain website functions and
          security.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-101">
          Details can be found in Webflow&apos;s privacy policy:{' '}
          <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-102">
            https://webflow.com/legal/eu-privacy-policy
          </a>
          .
        </p>
        <p className="leading-relaxed mb-4" data-id="element-103">
          The use of Webflow is based on our legitimate interest in presenting
          our online services as reliably as possible. Where consent has been
          requested, processing is carried out exclusively on the basis of that
          consent and can be revoked at any time.
        </p>
      </section>

      <section data-id="element-104">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-105">
          3. General information and mandatory information
        </h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-106">
          Data protection
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-107">
          We take the protection of your personal data very seriously. We treat
          your personal data confidentially and in accordance with applicable
          data protection legislation and this Privacy Policy.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-108">
          When you use this website, various personal data may be collected.
          This Privacy Policy explains what data we collect, how we use it and
          for what purpose.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-109">
          Responsible Entity
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-110">
          The Responsible Entity for data processing on this website is:
        </p>
        <p className="leading-relaxed mb-4" data-id="element-111">
          CRM Kraft LLC
          <br data-id="element-112" />
          Represented by: Justus Kraft
          <br data-id="element-113" />
          7901 4th St. N, Ste. 300
          <br data-id="element-114" />
          St. Petersburg, FL 33702
          <br data-id="element-115" />
          United States of America
          <br data-id="element-116" />
          Phone: +49 157 35999071
          <br data-id="element-117" />
          Email: justus@crm-kraft.de
        </p>
        <p className="leading-relaxed mb-4" data-id="element-118">
          The Responsible Entity is the natural or legal person who alone or
          jointly with others determines the purposes and means of processing
          personal data.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-119">
          Retention period
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-120">
          Unless a more specific retention period is stated in this Privacy
          Policy, your personal data will remain with us until the purpose for
          processing no longer applies. If you make a legitimate request for
          deletion or withdraw consent, your data will be deleted unless we have
          other legally permissible reasons for retaining it.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-121">
          SSL/TLS encryption
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-122">
          This site uses SSL/TLS encryption for security reasons and to protect
          the transmission of confidential content. When SSL/TLS encryption is
          active, data you transmit to us cannot be read by third parties.
        </p>
      </section>

      <section data-id="element-123">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-124">
          4. Data collection on this website
        </h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-125">Cookies</h3>
        <p className="leading-relaxed mb-4" data-id="element-126">
          Our website uses cookies. Cookies are small text files that do not
          cause any damage to your device. They may be stored temporarily for a
          session or permanently until you delete them or your browser deletes
          them automatically.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-127">
          Contact form
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-128">
          If you send us enquiries using the contact form, your details from the
          form, including the contact details you provide, will be stored by us
          for the purpose of processing your enquiry and in case of follow-up
          questions. We do not share this data without your consent.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-129">
          Enquiries by email or phone
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-130">
          If you contact us by email or phone, we will store and process your
          enquiry, including any personal data arising from it, for the purpose
          of handling your request. We do not share this data without your
          consent.
        </p>
      </section>

      <section data-id="element-131">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-132">
          5. Plugins and tools
        </h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-133">YouTube</h3>
        <p className="leading-relaxed mb-4" data-id="element-134">
          This website embeds videos from YouTube. The operator of the website
          is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
          Ireland. Further information about how YouTube handles user data can
          be found in YouTube&apos;s privacy policy:{' '}
          <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-135">
            https://policies.google.com/privacy?hl=en
          </a>
          .
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-136">
          Google Web Fonts
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-137">
          This site uses web fonts provided by Google for consistent typography.
          When you access a page, your browser loads the necessary web fonts
          into its browser cache in order to display texts and fonts correctly.
        </p>
      </section>
    </div>;
}